/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { PolymerTubeVisual, PolymerTubeParams } from '../visual/polymer-tube-mesh';
import { PolymerGapVisual, PolymerGapParams } from '../visual/polymer-gap-cylinder';
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { UnitsRepresentation } from '../units-representation';
import { StructureRepresentationProvider, StructureRepresentationStateBuilder } from '../representation';
import { Representation } from '../../../mol-repr/representation';
import { Unit } from '../../../mol-model/structure';
var PuttyVisuals = {
    'polymer-tube': function (ctx, getParams) { return UnitsRepresentation('Polymer tube mesh', ctx, getParams, PolymerTubeVisual); },
    'polymer-gap': function (ctx, getParams) { return UnitsRepresentation('Polymer gap cylinder', ctx, getParams, PolymerGapVisual); },
};
export var PuttyParams = __assign(__assign(__assign({}, PolymerTubeParams), PolymerGapParams), { sizeFactor: PD.Numeric(0.2, { min: 0, max: 10, step: 0.01 }), visuals: PD.MultiSelect(['polymer-tube', 'polymer-gap'], PD.objectToOptions(PuttyVisuals)) });
export function getPuttyParams(ctx, structure) {
    var params = PD.clone(PuttyParams);
    var hasNucleotides = false;
    var hasGaps = false;
    structure.units.forEach(function (u) {
        if (!hasNucleotides && Unit.isAtomic(u) && u.nucleotideElements.length)
            hasNucleotides = true;
        if (!hasGaps && u.gapElements.length)
            hasGaps = true;
    });
    params.visuals.defaultValue = ['polymer-tube'];
    if (hasGaps)
        params.visuals.defaultValue.push('polymer-gap');
    return params;
}
export function PuttyRepresentation(ctx, getParams) {
    return Representation.createMulti('Putty', ctx, getParams, StructureRepresentationStateBuilder, PuttyVisuals);
}
export var PuttyRepresentationProvider = StructureRepresentationProvider({
    name: 'putty',
    label: 'Putty',
    description: 'Displays a tube smoothly following the trace atoms of polymers.',
    factory: PuttyRepresentation,
    getParams: getPuttyParams,
    defaultValues: PD.getDefaultValues(PuttyParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uncertainty' },
    isApplicable: function (structure) { return structure.polymerResidueCount > 0; },
});
//# sourceMappingURL=putty.js.map